export default __webpack_public_path__ + "static/media/Left.eb457373.svg";